<template>
  <div id="topicColumnDetail">
    <topBanner v-if="!isShare" :appName="appName" :detail="1" @topicDetail="topicDetail"></topBanner>
    <!--    <div class="topicDetail">-->
    <!--      <detail-head :topicInfo="topicInfo" :bg="bg" :themeColor="themeColor"></detail-head>-->
    <!--      <detail-content :topicList="topicList"></detail-content>-->
    <!--    </div>-->
    <discussDetail v-if="discussDetail" :discussItem="discussDetail" :isDetail="1"
                   @showSwiper="showSwiper"></discussDetail>

    <div class="topicDetailComments">

      <hot-comments :hotComments="hotComments" :govImage="govImage" v-if="isHotShow && hotComments"
                    :themeColor="themeColor"></hot-comments>
      <last-comments :lastComments="lastComments" :govImage="govImage" v-if="isLastShow && lastComments"
                     :themeColor="themeColor"></last-comments>
    </div>
    <div v-if="isHotShow ===false && isLastShow === false" class="noComments">
      <svg style="width: 0.68rem;height: 0.68rem;"
           xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink" viewBox='0 0 68 68'>
        <path fill-rule="evenodd" fill="rgb(221, 221, 221)"
              d="M59.304,58.292 L61.874,60.866 C63.383,62.376 63.627,64.580 62.422,65.787 C61.213,66.998 59.013,66.753 57.505,65.243 L52.040,59.769 C52.036,59.765 52.033,59.760 52.028,59.755 C51.460,59.185 50.694,58.858 49.889,58.847 L17.886,58.847 L17.845,58.847 C17.060,58.846 16.304,59.145 15.731,59.683 L15.731,59.683 C15.704,59.711 15.684,59.742 15.657,59.769 L10.193,65.243 C8.684,66.753 6.484,66.998 5.279,65.790 C4.070,64.583 4.314,62.376 5.823,60.866 L7.943,58.742 C6.225,58.493 4.591,57.772 3.244,56.617 C1.185,54.853 -0.000,52.275 -0.000,49.561 L-0.000,30.988 C-0.000,26.947 2.582,23.518 6.181,22.242 L6.181,9.320 C6.181,4.192 10.332,0.034 15.453,0.034 L52.541,0.034 C57.662,0.034 61.813,4.192 61.813,9.320 L61.813,22.242 C65.412,23.518 67.994,26.947 67.994,30.988 L67.994,46.465 C67.994,52.023 64.339,56.725 59.304,58.292 ZM55.631,12.416 C55.631,10.774 54.980,9.199 53.821,8.038 C52.662,6.877 51.090,6.225 49.450,6.225 L18.544,6.225 C16.904,6.225 15.332,6.877 14.173,8.038 C13.014,9.199 12.363,10.774 12.363,12.416 L12.363,22.242 C15.961,23.518 18.544,26.947 18.544,30.988 L18.544,35.632 C18.544,36.042 18.707,36.436 18.996,36.726 C19.286,37.016 19.679,37.179 20.089,37.179 L47.905,37.179 C48.315,37.179 48.708,37.016 48.998,36.726 C49.287,36.436 49.450,36.042 49.450,35.632 L49.450,30.988 C49.450,26.947 52.033,23.518 55.631,22.242 L55.631,12.416 ZM61.813,30.988 C61.813,29.279 60.429,27.893 58.722,27.893 C57.015,27.893 55.632,29.279 55.631,30.988 L55.631,40.275 L55.631,41.822 C55.631,42.233 55.469,42.626 55.179,42.917 C54.889,43.207 54.496,43.370 54.086,43.370 L13.908,43.370 C13.498,43.370 13.105,43.207 12.815,42.917 C12.525,42.626 12.363,42.233 12.363,41.822 L12.363,30.988 C12.362,29.279 10.979,27.893 9.272,27.893 C7.565,27.893 6.181,29.279 6.181,30.988 L6.181,49.561 C6.181,51.270 7.565,52.656 9.272,52.656 L58.722,52.656 C60.429,52.656 61.813,51.270 61.813,49.561 L61.813,30.988 ZM44.814,30.988 L23.180,30.988 C22.149,30.988 21.634,30.472 21.634,29.441 C21.634,28.409 22.149,27.893 23.180,27.893 L44.814,27.893 C45.845,27.893 46.360,28.409 46.360,29.441 C46.360,30.472 45.845,30.988 44.814,30.988 Z"/>
      </svg>
      <p style="color: #999999;font-size: 0.28rem;line-height: 0.48rem">暂无评论内容</p>
    </div>
    <BottomOpenApp @topicToApp="topicDetail"></BottomOpenApp>
    <CommentBox :topicInfo="topicInfo" :sid="sid" :discussID="discussID"></CommentBox>
  </div>
</template>
<script>
  import topBanner from '../components/topBanner'
  import hotComments from '../components/comments/hotComments.vue'
  import lastComments from '../components/comments/lastComments.vue'
  import discussDetail from '../components/discussDetail/discussDetail'
  import BottomOpenApp from '../components/BottomOpenApp'

  import CommentBox from '../components/CommentBox'

  import submit from '../tool/submit'
  import wxShareTool from '../tool/wxShare.js'
  import utils from '../tool/utils'

  export default {
    props: ['topicInfo', 'bg', 'topicList', 'sid', 'govImage', 'themeColor', 'appName', 'item'],
    data () {
      return {
        discussID: '',
        topicID: '',
        hotComments: {},
        isHotShow: false,
        lastComments: {},
        isLastShow: false,
        discussDetail: this.$route.params.topicItem,
        isShare: this.$route.params.topicItem || 0
      }
    },
    created () {
      this.discussID = this.$route.params.discussID
      this.topicID = this.$route.params.topicID
      const _this = this
      if (!this.$route.params.item) {
        submit.getTopicDiscussContent({
          sid: _this.sid,
          discussID: this.discussID
        }).then(({data}) => {
          if (data) {
            document.title = data.title
            var _item = []
            _item.push(data)
            _item = submit.parseImageStyle(_item, data.config || '')
            _this.discussDetail = _item && _item[0]
            if (Object.keys(_this.discussDetail).length > 0 && _this.sid) {
              wxShareTool.wxShare({
                sid: _this.sid,
                title: (_this.sid === 'tzwb' || _this.sid === 'test') && _this.discussDetail.content || _this.discussDetail.title, // 分享标题
                desc: _this.discussDetail.content, // 分享描述
                imgUrl: _this.discussDetail.imgUrl // 分享图标
              })
            }
          }
        })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        try {
          wxShareTool.wxShare({
            sid: _this.sid,
            title: (_this.sid === 'tzwb' || _this.sid === 'test') && _this.discussDetail.content || _this.discussDetail.title, // 分享标题
            desc: _this.discussDetail.content, // 分享描述
            imgUrl: _this.discussDetail.imgUrl // 分享图标
          })
        } catch (e) {
          console.log(e)
        }
      }
      submit.getHotComments({
        sid: _this.sid,
        rootID: _this.discussID,
        sourceType: 5,
        lastFileID: 0,
        rowNumber: 0,
        userID: -1
      }).then(({data}) => {
        if (data && data.list) {
          _this.hotComments = data.list
          if (_this.hotComments.length > 0) {
            _this.isHotShow = true
          }
        }
      })
        .catch(function (error) {
          console.log(error)
        })
      submit.getComments({
        sid: _this.sid,
        rootID: _this.discussID,
        sourceType: 5,
        lastFileID: 0,
        rowNumber: 0,
        _userID: -1
      }).then(({data}) => {
        if (data && data.list) {
          _this.lastComments = data.list
          if (_this.lastComments.length > 0) {
            _this.isLastShow = true
          }
        }
      })
        .catch(function (error) {
          console.log(error)
        })

      utils.evokeAppInit(_this.sid, _this.topicID, _this.discussID)
    },
    mounted () {
      // var _this = this
      // console.log('有没')
      // setTimeout(function () {
      //   // eslint-disable-next-line no-undef
      //   typeof evokeApp !== 'undefined' && typeof evokeApp.init === 'function' && evokeApp.init({
      //     ti: document.title || '',
      //     aid: _this.discussID,
      //     ty: '105',
      //     id: _this.discussID
      //   })
      // }, 800)
      const _this = this
      let _shareData = {
        ti: document.title || '',
        aid: _this.$route.params.discussID || _this.$route.params.topicID,
        ty: _this.$route.params.discussID ? '105' : '104',
        id: _this.$route.params.discussID || _this.$route.params.topicID,
        sid: _this.$route.params.sid
      }
      utils.wxLaunchChange('#btnOpenAppBanner', _this.topicDetail, '', 1, '', _shareData)
    },
    components: {
      topBanner,
      hotComments,
      lastComments,
      discussDetail,
      BottomOpenApp,
      CommentBox
    },
    methods: {
      topicDetail: function (e) {
        this.$emit('downApp', 'topicColumnDetail.vue ' + e)
      },
      showSwiper: function (list, index) {
        this.$emit('showSwiper', list, index)
      }
    }
  }
</script>
<style>
  #topicColumnDetail {
    margin-bottom: 55px;
  }

  .topicDetailComments {
    /*border-top: 0.1rem solid #ededed;*/
  }

  .noComments {
    border-top: 0.1rem solid #ededed;
    padding-top: 0.6rem;
    color: #999999;
    font-size: 0.28rem;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// topicColumnDetail.vue?60bf2d1a